module.exports = "<div class=\"container-fluid\">\r\n    <header></header>\r\n    <div class=\"row\">\r\n        <app-breadcrumb></app-breadcrumb>\r\n    </div>\r\n    <div class=\"row\">\r\n        <div class=\"col-lg-3 col-md-3 col-sm-4\">\r\n            <app-filter></app-filter>\r\n        </div>\r\n        <div class=\"col-lg-8 col-md-8 col-sm-8\">\r\n            <app-container></app-container>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main